import SignInInfo from './signInInfo';
import { LimeTrayLogo } from '../../../assets';
import '../index.scss';

export default function AuthSplitLayout({ children }) {
  return (
    <div className="signin-screen">
      <div className="container signin-flex">
        <div className="flex-50 sm-display-none">
          <SignInInfo />
        </div>
        <div className="flex-50 sm-flex-100">
          <div className="sign-in-form auth-panel">
            <div className="auth-panel-body">
              <div className="brand">
                <img className="limetrayLogo" src={LimeTrayLogo} alt="LimeTray" />
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}